import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Inspector } from '../viewmodels/analysis/inspection-reports/inspector';
import { BackendService } from './backend.service';

@Injectable()
export class InspectorsService {

  public constructor(private backendService: BackendService) { }

  public getInspectors(): Observable<Inspector[]> {

    return this.backendService.getAll<Inspector>(Inspector);
  }

}
